module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/audio-ce8c6.png";